import type { LocaleMessageBundle } from '../../types'

export const inventoryMessages: LocaleMessageBundle = {
  vi: {
    'inventory.stock.title': 'Tồn kho',
    'inventory.history.title': 'Lịch sử kho',
    'inventory.openingStock.title': 'Tồn đầu kỳ',
    'inventory.purchaseReceipt.title': 'Nhập hàng',
    'inventory.purchaseReceipt.actions.create': 'Tạo phiếu nhập',
    'inventory.purchaseReceipt.actions.addTab': 'Thêm phiếu nhập',
    'inventory.purchaseReceipt.actions.closeTab': 'Đóng phiếu nhập',
    'inventory.purchaseReceipt.actions.view': 'Xem chi tiết',
    'inventory.purchaseReceipt.actions.update': 'Cập nhật',
    'inventory.purchaseReceipt.actions.copy': 'Sao chép',
    'inventory.purchaseReceipt.actions.return': 'Trả hàng nhập',
    'inventory.purchaseReceipt.actions.cancel': 'Hủy',
    'inventory.purchaseReceipt.actions.delete': 'Xóa',
    'inventory.purchaseReceipt.actions.deleteTitle': 'Xóa phiếu nhập nháp',
    'inventory.purchaseReceipt.messages.deleteConfirm': 'Bạn có chắc muốn xóa phiếu nhập {code}?',
    'inventory.purchaseReceipt.actions.payment': 'Thanh toán',
    'inventory.purchaseReceipt.actions.payShipping': 'Thanh toán phí vận chuyển',
    'inventory.purchaseReceipt.actions.print': 'In phiếu',
    'inventory.purchaseReceipt.actions.export': 'Xuất Excel',
    'inventory.purchaseReceipt.export.error': 'Không thể xuất danh sách nhập hàng.',
    'inventory.purchaseReceipt.actions.cancelTitle': 'Huỷ phiếu nhập',
    'inventory.purchaseReceipt.actions.cancelConfirm': 'Hủy',
    'inventory.purchaseReceipt.fields.cancelReason': 'Lý do hủy',
    'inventory.purchaseReceipt.errors.cancelReasonRequired':
      'Lý do hủy phải có ít nhất 3 ký tự.',
    'inventory.purchaseReceipt.errors.cancelReasonTooLong':
      'Lý do hủy không được vượt quá {max} ký tự.',
    'inventory.purchaseReceipt.actions.guide': 'Hướng dẫn',
    'inventory.purchaseReceipt.actions.scanBarcode': 'Quét mã',
    'inventory.purchaseReceipt.actions.importExcel': 'Nhập Excel',
    'inventory.purchaseReceipt.actions.chooseExcelFile': 'Chọn file Excel',
    'inventory.purchaseReceipt.actions.downloadTemplate': 'Tải file mẫu',
    'inventory.purchaseReceipt.actions.viewGuide': 'Xem hướng dẫn',
    'inventory.purchaseReceipt.messages.cancelConfirm': 'Bạn có chắc muốn huỷ phiếu nhập {code}?',
    'inventory.purchaseReceipt.messages.shippingPaymentAmount': 'Số tiền chi cho đơn vị vận chuyển: {amount}',
    'inventory.purchaseReceipt.sections.general': 'Thông tin chung',
    'inventory.purchaseReceipt.sections.products': 'Sản phẩm nhập',
    'inventory.purchaseReceipt.sections.totals': 'Tổng kết',
    'inventory.shipping.section': 'Chi phí vận chuyển',
    'inventory.shipping.deliveryPartner': 'Đơn vị vận chuyển',
    'inventory.shipping.fee': 'Tổng phí vận chuyển',
    'inventory.shipping.payer.label': 'Bên chịu phí',
    'inventory.shipping.payer.shop': 'Cửa hàng trả',
    'inventory.shipping.payer.supplier': 'Nhà cung cấp trả',
    'inventory.shipping.payer.shared': 'Cùng trả',
    'inventory.shipping.supplierAmount': 'Phần nhà cung cấp chịu',
    'inventory.shipping.shopAmount': 'Phần cửa hàng chịu',
    'inventory.shipping.payee.label': 'Cửa hàng thanh toán cho',
    'inventory.shipping.payee.deliveryPartner': 'Đơn vị vận chuyển',
    'inventory.shipping.payee.supplier': 'Nhà cung cấp',
    'inventory.shipping.goodsTotal': 'Tổng tiền hàng',
    'inventory.shipping.supplierPayableShipping': 'Phí ship trả qua nhà cung cấp',
    'inventory.shipping.errors.partnerRequired': 'Vui lòng chọn đơn vị vận chuyển.',
    'inventory.shipping.errors.sharedAmount': 'Phần nhà cung cấp chịu phải lớn hơn 0 và nhỏ hơn tổng phí ship.',
    'inventory.shipping.errors.feeRange':
      'Tổng phí vận chuyển phải là số từ 0 đến {max} ₫. Ví dụ hợp lệ: 150.000',
    'inventory.purchaseReceipt.tabs.draft': 'Nhập hàng {number}',
    'inventory.purchaseReceipt.emptyLines':
      'Tìm sản phẩm theo SKU, barcode hoặc tên để thêm vào phiếu.',
    'inventory.purchaseReceipt.searchPlaceholder': 'Tìm sản phẩm theo tên, SKU, barcode...',
    'inventory.purchaseReceipt.emptyTitle': 'Chưa có sản phẩm nào',
    'inventory.purchaseReceipt.emptySubtitle': 'Tìm kiếm sản phẩm ở ô trên để thêm vào phiếu nhập',
    'inventory.purchaseReceipt.excel.title': 'Nhập hàng hàng loạt bằng Excel',
    'inventory.purchaseReceipt.excel.dropHint': 'Kéo & thả file Excel vào đây hoặc chọn File',
    'inventory.purchaseReceipt.excel.supportedFormats':
      'Hỗ trợ định dạng: .xlsx, .xls (tối đa 5MB)',
    'inventory.purchaseReceipt.excel.guideTitle': 'Hướng dẫn nhập file',
    'inventory.purchaseReceipt.excel.templateHint': 'Tải file mẫu để nhập dữ liệu',
    'inventory.purchaseReceipt.excel.detailHint': 'Xem hướng dẫn chi tiết',
    'inventory.purchaseReceipt.excel.detailGuideTitle': 'Hướng dẫn nhập dữ liệu từ Excel',
    'inventory.purchaseReceipt.excel.guideStepDownload': 'Bước 1: Tải file mẫu Excel.',
    'inventory.purchaseReceipt.excel.guideStepFill':
      'Bước 2: Điền SKU/Barcode, tên sản phẩm, đơn vị, giá nhập, số lượng và ghi chú.',
    'inventory.purchaseReceipt.excel.guideStepImport':
      'Bước 3: Chọn file đã hoàn thành và bấm xử lý dữ liệu để thêm vào danh sách sản phẩm.',
    'inventory.purchaseReceipt.excel.guideNote':
      'Hỗ trợ file .xlsx và .xls. Hệ thống đối chiếu sản phẩm theo SKU/Barcode; các dòng không tìm thấy sản phẩm sẽ được bỏ qua.',
    'inventory.purchaseReceipt.notePlaceholder': 'Nhập ghi chú (không bắt buộc)',
    'inventory.purchaseReceipt.attachments.section': 'Ảnh chứng từ',
    'inventory.purchaseReceipt.attachments.hint':
      'Tối đa 5 ảnh, tổng dung lượng 50MB (jpg, png, webp). Ảnh sẽ được tải lên khi bấm Lưu/Hoàn thành.',
    'inventory.purchaseReceipt.attachments.pendingHint':
      'Ảnh đang chờ được tải lên.',
    'inventory.purchaseReceipt.attachments.add': 'Thêm ảnh',
    'inventory.purchaseReceipt.attachments.empty': 'Chưa có ảnh chứng từ',
    'inventory.purchaseReceipt.errors.attachmentUploadFailed': 'Upload ảnh chứng từ không thành công.',
    'inventory.purchaseReceipt.errors.attachmentTypeInvalid': 'Chỉ cho phép ảnh định dạng jpg, png, webp.',
    'inventory.purchaseReceipt.errors.attachmentLimitExceeded':
      'Vượt giới hạn: tối đa 5 ảnh và tổng dung lượng 50MB.',
    'inventory.purchaseReceipt.labels.notImported': 'Không nhập kho',
    'inventory.purchaseReceipt.location.actions.manage': 'Phân bổ vị trí',
    'inventory.purchaseReceipt.location.actions.add': 'Thêm vị trí',
    'inventory.purchaseReceipt.location.fields.location': 'Vị trí',
    'inventory.purchaseReceipt.location.fields.quantity': 'Số lượng cơ sở',
    'inventory.purchaseReceipt.location.total': 'Tổng cơ sở',
    'inventory.purchaseReceipt.location.allocated': 'Đã phân bổ',
    'inventory.purchaseReceipt.location.unallocated': 'Chưa phân bổ',
    'inventory.purchaseReceipt.location.validation.duplicate': 'Không được chọn trùng vị trí.',
    'inventory.purchaseReceipt.location.validation.exceeds': 'Tổng phân bổ không được vượt số lượng nhập.',
    'inventory.purchaseReceipt.location.validation.required': 'Vui lòng phân bổ đủ số lượng vào vị trí trước khi lưu.',
    'inventory.purchaseReceipt.location.validation.fullRequired': 'Bắt buộc: chọn vị trí và phân bổ đủ toàn bộ số lượng.',
    'inventory.purchaseReceipt.location.validation.defaultRequired': 'Chi nhánh chưa có vị trí mặc định để nhập hàng.',
    'inventory.purchaseReceipt.location.detail.title': 'Phân bổ vị trí',
    'inventory.purchaseReceipt.location.detail.allocated': 'Tổng đã phân bổ',
    'inventory.purchaseReceipt.location.detail.unallocated': 'Chưa có phân bổ vị trí',
    'inventory.purchaseReceipt.location.empty': 'Sản phẩm chưa được gán vị trí lưu trữ.',
    'inventory.statuses.draft': 'Nháp',
    'inventory.statuses.posted': 'Hoàn thành',
    'inventory.statuses.cancelled': 'Đã huỷ',
    'inventory.filters.receiptSearchPlaceholder': 'Nhập mã phiếu',
    'inventory.filters.returnSearchPlaceholder': 'Nhập mã trả / mã phiếu nhập',
    'inventory.filters.hasDebtYes': 'Còn nợ',
    'inventory.filters.hasDebtNo': 'Đã thanh toán',
    'inventory.purchaseReturn.title': 'Trả hàng nhập',
    'inventory.purchaseReturn.actions.create': 'Thêm trả hàng nhập',
    'inventory.purchaseReturn.actions.update': 'Cập nhật trả hàng nhập',
    'inventory.purchaseReturn.actions.cancel': 'Hủy',
    'inventory.purchaseReturn.actions.delete': 'Xóa',
    'inventory.purchaseReturn.actions.deleteTitle': 'Xóa phiếu trả hàng nhập nháp',
    'inventory.purchaseReturn.messages.deleteConfirm': 'Bạn có chắc muốn xóa phiếu trả hàng nhập {code}?',
    'inventory.purchaseReturn.actions.cancelTitle': 'Huỷ phiếu trả',
    'inventory.purchaseReturn.actions.cancelConfirm': 'Hủy',
    'inventory.purchaseReturn.fields.cancelReason': 'Lý do hủy',
    'inventory.purchaseReturn.errors.cancelReasonRequired':
      'Lý do hủy phải có ít nhất 3 ký tự.',
    'inventory.purchaseReturn.errors.cancelReasonTooLong':
      'Lý do hủy không được vượt quá {max} ký tự.',
    'inventory.purchaseReturn.actions.print': 'In phiếu',
    'inventory.purchaseReturn.messages.cancelConfirm': 'Bạn có chắc muốn huỷ phiếu trả {code}?',
    'inventory.purchaseReturn.sections.receipt': 'Phiếu nhập gốc',
    'inventory.purchaseReturn.sections.products': 'Sản phẩm trả',
    'inventory.purchaseReturn.emptyLines':
      'Chọn phiếu nhập đã hoàn thành để tải sản phẩm có thể trả.',
    'inventory.hints.returnQuantity': 'Nhập số lượng > 0 cho sản phẩm cần trả',
    'inventory.fields.product': 'Sản phẩm',
    'inventory.fields.sku': 'Mã sản phẩm',
    'inventory.fields.branch': 'Chi nhánh',
    'inventory.fields.unit': 'Đơn vị',
    'inventory.fields.quantityOnHand': 'Tồn kho',
    'inventory.fields.allocatedQuantity': 'Đã phân vị trí',
    'inventory.fields.unallocatedQuantity': 'Chưa phân vị trí',
    'inventory.fields.location': 'Vị trí',
    'inventory.fields.averageCost': 'Giá vốn TB',
    'inventory.fields.stockValue': 'Giá trị tồn',
    'inventory.fields.occurredAt': 'Thời gian',
    'inventory.fields.movementType': 'Loại phát sinh',
    'inventory.movementTypes.opening_balance': 'Tồn đầu kỳ',
    'inventory.movementTypes.purchase_receipt': 'Nhập hàng',
    'inventory.movementTypes.purchase_receipt_cancel': 'Hủy nhập hàng',
    'inventory.movementTypes.purchase_return': 'Trả hàng nhập',
    'inventory.movementTypes.sales_invoice': 'Bán hàng',
    'inventory.movementTypes.sale_return': 'Khách trả hàng',
    'inventory.movementTypes.sale_exchange': 'Xuất hàng đổi',
    'inventory.movementTypes.production_material_issue': 'Xuất nguyên vật liệu',
    'inventory.movementTypes.production_output_receipt': 'Phiếu sản xuất',
    'inventory.movementTypes.inventory_check': 'Kiểm kho',
    'inventory.movementTypes.stock_transfer_out': 'Xuất chuyển hàng',
    'inventory.movementTypes.stock_transfer_in': 'Nhập chuyển hàng',
    'inventory.movementTypes.stock_transfer_return': 'Hoàn chênh lệch chuyển hàng',
    'inventory.movementTypes.stock_transfer_cancel': 'Hoàn kho do hủy chuyển hàng',
    'inventory.fields.sourceCode': 'Mã chứng từ',
    'inventory.fields.returnCode': 'Mã trả hàng nhập',
    'inventory.fields.quantityChange': 'SL thay đổi',
    'inventory.fields.quantityAfter': 'SL sau',
    'inventory.fields.endingStock': 'Tồn cuối',
    'inventory.fields.unitCost': 'Đơn giá vốn',
    'inventory.fields.receiptCode': 'Mã nhập hàng',
    'inventory.fields.receiptDate': 'Ngày nhập',
    'inventory.fields.totalAmount': 'Tổng tiền',
    'inventory.fields.status': 'Trạng thái',
    'inventory.fields.performedBy': 'Người nhập',
    'inventory.fields.updatedAt': 'Cập nhật lúc',
    'inventory.fields.createdAt': 'Tạo lúc',
    'inventory.fields.postedAt': 'Hoàn thành lúc',
    'inventory.fields.cancelledAt': 'Huỷ lúc',
    'inventory.fields.balancedAt': 'Cân bằng lúc',
    'inventory.fields.cancelReason': 'Lý do hủy',
    'inventory.fields.note': 'Ghi chú',
    'inventory.fields.paidAmount': 'Đã trả',
    'inventory.fields.quantity': 'Số lượng',
    'inventory.fields.returnQuantity': 'Số lượng trả',
    'inventory.fields.returnDate': 'Ngày trả',
    'inventory.fields.purchaseReceipt': 'Phiếu nhập',
    'inventory.fields.lineTotal': 'Thành tiền',
    'inventory.fields.itemCount': 'Số mặt hàng',
    'inventory.fields.totalQuantity': 'Tổng số lượng',
    'inventory.fields.discountAmount': 'Giảm giá',
    'inventory.fields.returnableQuantity': 'Còn có thể trả',
    'inventory.fields.debtReducedAmount': 'Giảm công nợ',
    'inventory.stockLocation.title': 'Phân bổ tồn kho theo vị trí',
    'inventory.stockLocation.subtitle': '{product} tại {branch}',
    'inventory.stockLocation.actions.manage': 'Quản lý vị trí tồn',
    'inventory.stockLocation.actions.add': 'Thêm vị trí',
    'inventory.stockLocation.summary.total': 'Tổng tồn',
    'inventory.stockLocation.summary.allocated': 'Đã phân bổ',
    'inventory.stockLocation.summary.unallocated': 'Chưa phân bổ',
    'inventory.stockLocation.summary.default': 'Vị trí mặc định',
    'inventory.stockLocation.summary.byTree': 'Tổng hợp theo cây vị trí',
    'inventory.stockLocation.empty': 'Sản phẩm chưa được phân bổ vào vị trí nào.',
    'inventory.stockLocation.help':
      'Tổng số lượng theo vị trí không được vượt quá tổng tồn kho. Chỉ vị trí cấp thấp nhất được chọn.',
    'inventory.stockLocation.validation.duplicate': 'Mỗi vị trí chỉ được chọn một lần.',
    'inventory.stockLocation.validation.exceeds': 'Tổng phân bổ không được vượt quá tổng tồn kho.',
    'inventory.actions.saveDraft': 'Lưu tạm',
    'inventory.actions.complete': 'Hoàn thành',
    'inventory.actions.payFull': 'Trả đủ',
    'inventory.paymentMethods.cash': 'Tiền mặt',
    'inventory.paymentMethods.card': 'Thẻ',
    'inventory.paymentMethods.transfer': 'Chuyển khoản',
    'inventory.errors.receiptMissingParty': 'Cần chọn chi nhánh và nhà cung cấp.',
    'inventory.errors.receiptMissingItems': 'Cần chọn sản phẩm, đơn vị và số lượng nhập hợp lệ.',
    'inventory.errors.unitCostExceeded': 'Đơn giá vốn không được vượt quá {max}.',
    'inventory.errors.quantityExceeded': 'Số lượng không được vượt quá {max}.',
    'inventory.errors.quantityMustBeInteger': 'Đơn vị này chỉ cho phép số lượng nguyên.',
    'inventory.errors.amountExceeded': 'Tổng tiền không được vượt quá {max}.',
    'inventory.errors.returnMissingReceipt': 'Cần chọn phiếu nhập đã hoàn thành.',
    'inventory.errors.returnMissingItems': 'Cần nhập ít nhất một dòng sản phẩm trả hợp lệ.',
    'inventory.errors.returnQuantityExceeded':
      'Số lượng trả không được vượt quá số lượng còn có thể trả.',
    'inventory.errors.paidAmountExceeded':
      'Số tiền đã trả không được vượt quá tổng tiền phiếu nhập.',
    'inventory.errors.saveFailed': 'Không thể lưu dữ liệu kho',
    'inventory.fields.checkCode': 'Mã phiếu kiểm',
    'inventory.fields.checkDate': 'Ngày kiểm',
    'inventory.inventoryCheck.actions.create': 'Thêm kiểm kho',
    'inventory.inventoryCheck.actions.edit': 'Cập nhật',
    'inventory.inventoryCheck.actions.view': 'Chi tiết kiểm kho',
    'inventory.inventoryCheck.actions.addProduct': 'Thêm hàng hóa',
    'inventory.inventoryCheck.actions.import': 'Nhập Excel',
    'inventory.inventoryCheck.actions.export': 'Xuất Excel',
    'inventory.inventoryCheck.actions.print': 'In phiếu',
    'inventory.inventoryCheck.actions.copy': 'Sao chép',
    'inventory.inventoryCheck.actions.delete': 'Xóa phiếu',
    'inventory.inventoryCheck.actions.cancel': 'Hủy',
    'inventory.inventoryCheck.actions.balance': 'Hoàn thành',
    'inventory.inventoryCheck.actions.merge': 'Gộp phiếu',
    'inventory.inventoryCheck.actions.clearActualQuantity': 'Xóa số lượng thực tế',
    'inventory.inventoryCheck.sections.general': 'Thông tin chung',
    'inventory.inventoryCheck.sections.products': 'Sản phẩm kiểm kho',
    'inventory.inventoryCheck.sections.totals': 'Tổng kết',
    'inventory.inventoryCheck.sections.statistics': 'Tổng kết',
    'inventory.inventoryCheck.mergeTitle': 'Gộp phiếu kiểm kho',
    'inventory.inventoryCheck.mergeConfirm': 'Gộp {count} phiếu nháp đã chọn thành một phiếu mới?',
    'inventory.inventoryCheck.fields.totalItems': 'Tổng hàng',
    'inventory.inventoryCheck.fields.checkedItems': 'Đã kiểm',
    'inventory.inventoryCheck.fields.uncheckedItems': 'Chưa kiểm',
    'inventory.inventoryCheck.fields.costPrice': 'Giá vốn trung bình',
    'inventory.inventoryCheck.fields.systemQuantity': 'Tồn hệ thống',
    'inventory.inventoryCheck.fields.actualQuantity': 'Thực tế',
    'inventory.inventoryCheck.fields.differenceQuantity': 'Số lượng lệch',
    'inventory.inventoryCheck.fields.differenceValue': 'Giá trị lệch',
    'inventory.inventoryCheck.statuses.draft': 'Nháp',
    'inventory.inventoryCheck.statuses.balanced': 'Đã cân bằng',
    'inventory.inventoryCheck.statuses.cancelled': 'Đã hủy',
    'inventory.inventoryCheck.filters.searchPlaceholder': 'Nhập mã phiếu',
    'inventory.inventoryCheck.filters.hasDifference': 'Có lệch kho',
    'inventory.inventoryCheck.filters.yes': 'Có',
    'inventory.inventoryCheck.filters.no': 'Không',
    'inventory.inventoryCheck.cancelTitle': 'Hủy phiếu kiểm kho',
    'inventory.inventoryCheck.deleteTitle': 'Xóa phiếu kiểm kho',
    'inventory.inventoryCheck.deleteConfirm':
      'Bạn có chắc muốn xóa phiếu kiểm kho {code}? Chỉ phiếu nháp mới được xóa.',
    'inventory.inventoryCheck.cancelConfirm':
      'Bạn có chắc muốn hủy phiếu kiểm kho {code}? Tồn kho sẽ được phục hồi.',
    'inventory.inventoryCheck.actions.cancelConfirm': 'Hủy',
    'inventory.inventoryCheck.messages.cancelled': 'Đã hủy phiếu kiểm kho.',
    'inventory.inventoryCheck.summary.checked': 'Đã kiểm',
    'inventory.inventoryCheck.summary.difference': 'Tổng lệch',
    'inventory.inventoryCheck.location.title': 'Vị trí lưu trữ & kiểm kê chi tiết',
    'inventory.inventoryCheck.location.unallocated': 'Tồn chưa phân bổ vị trí',
    'inventory.inventoryCheck.location.empty': 'Sản phẩm chưa gán vị trí lưu trữ',
    'inventory.inventoryCheck.emptyItems': 'Chưa có hàng hóa trong phiếu.',
    'inventory.inventoryCheck.importResult':
      'Đã cập nhật {updated} dòng, thêm mới {added} dòng. Bỏ qua {skipped} dòng.',
    'inventory.inventoryCheck.errors.branchAndItemsRequired':
      'Vui lòng chọn chi nhánh và thêm ít nhất một hàng hóa.',
    'inventory.inventoryCheck.errors.uncheckedItems':
      'Vui lòng nhập số lượng thực tế cho tất cả hàng hóa.',
    'inventory.inventoryCheck.errors.futureDate': 'Ngày kiểm kho không được ở tương lai.',
    'inventory.inventoryCheck.errors.quantityNegative': 'Số lượng thực tế không được âm.',
    'inventory.inventoryCheck.errors.actualQuantityTotalExceeded':
      'Tổng số lượng thực tế của tất cả vị trí không được vượt quá {max}.',
    'inventory.inventoryCheck.import.title': 'Nhập danh sách kiểm kho',
    'inventory.inventoryCheck.import.subtitle':
      'Tải file mẫu, nhập dữ liệu rồi kiểm tra trước khi nhập.',
    'inventory.inventoryCheck.import.templateTitle': 'Tải file mẫu',
    'inventory.inventoryCheck.import.templateDescription':
      'File mẫu có sẵn hướng dẫn và các cột cần thiết cho kiểm kho.',
    'inventory.inventoryCheck.import.downloadTemplate': 'Tải file mẫu Excel',
    'inventory.inventoryCheck.import.requiredLegend':
      'Thông tin định danh sản phẩm cần có Mã sản phẩm hoặc Barcode.',
    'inventory.inventoryCheck.import.conditionalLegend':
      'Số lượng thực tế có thể để trống nếu chưa kiểm.',
    'inventory.inventoryCheck.import.notes.identifiers':
      'Hệ thống đối chiếu sản phẩm theo Mã sản phẩm rồi Barcode.',
    'inventory.inventoryCheck.import.notes.quantity':
      'Chỉ nhập số lượng thực tế không âm và ghi chú nếu cần.',
    'inventory.inventoryCheck.import.notes.format':
      'Hỗ trợ file .xlsx, .xls; dung lượng tối đa 5 MB.',
    'inventory.inventoryCheck.import.fileTitle': 'Chọn file cần nhập',
    'inventory.inventoryCheck.import.fileDescription':
      'Hệ thống sẽ đọc từng dòng trước khi cập nhật vào phiếu kiểm kho.',
    'inventory.inventoryCheck.import.chooseFile': 'Chọn file Excel',
    'inventory.inventoryCheck.import.supportedFormats': 'Hỗ trợ .xlsx, .xls; tối đa 5 MB',
    'inventory.inventoryCheck.import.rowCount': '{count} dòng hợp lệ',
    'inventory.inventoryCheck.import.process': 'Nhập {count} dòng',
    'inventory.inventoryCheck.import.errors.invalidFileType': 'Vui lòng chọn file .xlsx hoặc .xls.',
    'inventory.inventoryCheck.import.errors.fileTooLarge': 'File Excel không được vượt quá 5 MB.',
    'inventory.inventoryCheck.import.errors.noRows': 'File không có dòng dữ liệu kiểm kho hợp lệ.',
    'inventory.inventoryCheck.import.errors.cannotRead':
      'Không thể đọc file Excel. Vui lòng kiểm tra lại file.',
    'inventory.inventoryCheck.import.errors.invalidRows':
      'File có {count} dòng không hợp lệ: {reasons}',
  },
  en: {
    'inventory.stock.title': 'Stock',
    'inventory.history.title': 'Stock history',
    'inventory.openingStock.title': 'Opening stock',
    'inventory.purchaseReceipt.title': 'Purchase receipts',
    'inventory.purchaseReceipt.actions.create': 'Create receipt',
    'inventory.purchaseReceipt.actions.addTab': 'Add receipt',
    'inventory.purchaseReceipt.actions.closeTab': 'Close receipt',
    'inventory.purchaseReceipt.actions.view': 'View detail',
    'inventory.purchaseReceipt.actions.update': 'Update',
    'inventory.purchaseReceipt.actions.copy': 'Copy',
    'inventory.purchaseReceipt.actions.return': 'Purchase return',
    'inventory.purchaseReceipt.actions.cancel': 'Cancel',
    'inventory.purchaseReceipt.actions.delete': 'Delete',
    'inventory.purchaseReceipt.actions.deleteTitle': 'Delete draft purchase receipt',
    'inventory.purchaseReceipt.messages.deleteConfirm': 'Delete purchase receipt {code}?',
    'inventory.purchaseReceipt.actions.payment': 'Payment',
    'inventory.purchaseReceipt.actions.payShipping': 'Pay shipping fee',
    'inventory.purchaseReceipt.actions.print': 'Print',
    'inventory.purchaseReceipt.actions.export': 'Export Excel',
    'inventory.purchaseReceipt.export.error': 'Unable to export the purchase receipt list.',
    'inventory.purchaseReceipt.actions.cancelTitle': 'Cancel purchase receipt',
    'inventory.purchaseReceipt.actions.cancelConfirm': 'Cancel',
    'inventory.purchaseReceipt.fields.cancelReason': 'Cancel reason',
    'inventory.purchaseReceipt.errors.cancelReasonRequired':
      'Cancel reason must be at least 3 characters.',
    'inventory.purchaseReceipt.errors.cancelReasonTooLong':
      'Cancel reason must not exceed {max} characters.',
    'inventory.purchaseReceipt.actions.guide': 'Guide',
    'inventory.purchaseReceipt.actions.scanBarcode': 'Scan barcode',
    'inventory.purchaseReceipt.actions.importExcel': 'Import Excel',
    'inventory.purchaseReceipt.actions.chooseExcelFile': 'Choose Excel file',
    'inventory.purchaseReceipt.actions.downloadTemplate': 'Download template',
    'inventory.purchaseReceipt.actions.viewGuide': 'View guide',
    'inventory.purchaseReceipt.messages.cancelConfirm': 'Cancel purchase receipt {code}?',
    'inventory.purchaseReceipt.messages.shippingPaymentAmount': 'Amount paid to the delivery partner: {amount}',
    'inventory.purchaseReceipt.sections.general': 'General information',
    'inventory.purchaseReceipt.sections.products': 'Products',
    'inventory.purchaseReceipt.sections.totals': 'Totals',
    'inventory.shipping.section': 'Shipping cost',
    'inventory.shipping.deliveryPartner': 'Delivery partner',
    'inventory.shipping.fee': 'Total shipping fee',
    'inventory.shipping.payer.label': 'Fee payer',
    'inventory.shipping.payer.shop': 'Shop pays',
    'inventory.shipping.payer.supplier': 'Supplier pays',
    'inventory.shipping.payer.shared': 'Shared',
    'inventory.shipping.supplierAmount': 'Supplier share',
    'inventory.shipping.shopAmount': 'Shop share',
    'inventory.shipping.payee.label': 'Shop pays fee to',
    'inventory.shipping.payee.deliveryPartner': 'Delivery partner',
    'inventory.shipping.payee.supplier': 'Supplier',
    'inventory.shipping.goodsTotal': 'Goods total',
    'inventory.shipping.supplierPayableShipping': 'Shipping payable to supplier',
    'inventory.shipping.errors.partnerRequired': 'Select a delivery partner.',
    'inventory.shipping.errors.sharedAmount': 'The supplier share must be greater than zero and less than the shipping fee.',
    'inventory.shipping.errors.feeRange':
      'The shipping fee must be a number from 0 to {max} VND. Example: 150,000',
    'inventory.purchaseReceipt.tabs.draft': 'Purchase receipt {number}',
    'inventory.purchaseReceipt.emptyLines': 'Search by SKU, barcode, or product name to add items.',
    'inventory.purchaseReceipt.searchPlaceholder': 'Search product by name, SKU, barcode...',
    'inventory.purchaseReceipt.emptyTitle': 'No products yet',
    'inventory.purchaseReceipt.emptySubtitle':
      'Search for products above to add them to this receipt',
    'inventory.purchaseReceipt.excel.title': 'Bulk import with Excel',
    'inventory.purchaseReceipt.excel.dropHint': 'Drag and drop an Excel file here or',
    'inventory.purchaseReceipt.excel.supportedFormats': 'Supported formats: .xlsx, .xls (max 5MB)',
    'inventory.purchaseReceipt.excel.guideTitle': 'File import guide',
    'inventory.purchaseReceipt.excel.templateHint': 'Download the template before importing data',
    'inventory.purchaseReceipt.excel.detailHint': 'View detailed instructions',
    'inventory.purchaseReceipt.excel.detailGuideTitle': 'Excel data import guide',
    'inventory.purchaseReceipt.excel.guideStepDownload': 'Step 1: Download the Excel template.',
    'inventory.purchaseReceipt.excel.guideStepFill':
      'Step 2: Fill in SKU/Barcode, product name, unit, purchase price, quantity, and note.',
    'inventory.purchaseReceipt.excel.guideStepImport':
      'Step 3: Select the completed file and process it to add products to the list.',
    'inventory.purchaseReceipt.excel.guideNote':
      'Files in .xlsx and .xls format are supported. Products are matched by SKU/Barcode; rows with no matching product are skipped.',
    'inventory.purchaseReceipt.notePlaceholder': 'Enter note (optional)',
    'inventory.purchaseReceipt.attachments.section': 'Receipt attachments',
    'inventory.purchaseReceipt.attachments.hint':
      'Maximum 5 images, 50MB total (jpg, png, webp). Images upload when you save or complete the receipt.',
    'inventory.purchaseReceipt.attachments.pendingHint': 'Images waiting to be uploaded.',
    'inventory.purchaseReceipt.attachments.add': 'Add images',
    'inventory.purchaseReceipt.attachments.empty': 'No attachments',
    'inventory.purchaseReceipt.errors.attachmentUploadFailed': 'Failed to upload receipt attachments.',
    'inventory.purchaseReceipt.errors.attachmentTypeInvalid': 'Only jpg, png and webp images are allowed.',
    'inventory.purchaseReceipt.errors.attachmentLimitExceeded':
      'Limit exceeded: maximum 5 images and 50MB total.',
    'inventory.purchaseReceipt.labels.notImported': 'Not imported',
    'inventory.purchaseReceipt.location.actions.manage': 'Allocate locations',
    'inventory.purchaseReceipt.location.actions.add': 'Add location',
    'inventory.purchaseReceipt.location.fields.location': 'Location',
    'inventory.purchaseReceipt.location.fields.quantity': 'Base quantity',
    'inventory.purchaseReceipt.location.total': 'Total base',
    'inventory.purchaseReceipt.location.allocated': 'Allocated',
    'inventory.purchaseReceipt.location.unallocated': 'Unallocated',
    'inventory.purchaseReceipt.location.validation.duplicate': 'A location cannot be selected more than once.',
    'inventory.purchaseReceipt.location.validation.exceeds': 'Allocated quantity cannot exceed the receipt quantity.',
    'inventory.purchaseReceipt.location.validation.required': 'Allocate the full quantity to locations before saving.',
    'inventory.purchaseReceipt.location.validation.fullRequired': 'Required: select locations covering the full quantity.',
    'inventory.purchaseReceipt.location.validation.defaultRequired': 'The branch has no default receiving location configured.',
    'inventory.purchaseReceipt.location.detail.title': 'Location allocation',
    'inventory.purchaseReceipt.location.detail.allocated': 'Total allocated',
    'inventory.purchaseReceipt.location.detail.unallocated': 'No location allocation',
    'inventory.purchaseReceipt.location.empty': 'Product has no assigned storage locations.',
    'inventory.statuses.draft': 'Draft',
    'inventory.statuses.posted': 'Completed',
    'inventory.statuses.cancelled': 'Cancelled',
    'inventory.filters.receiptSearchPlaceholder': 'Enter receipt code',
    'inventory.filters.returnSearchPlaceholder': 'Enter return / receipt code',
    'inventory.filters.hasDebtYes': 'Has debt',
    'inventory.filters.hasDebtNo': 'Paid',
    'inventory.purchaseReturn.title': 'Purchase returns',
    'inventory.purchaseReturn.actions.create': 'Create return',
    'inventory.purchaseReturn.actions.update': 'Update',
    'inventory.purchaseReturn.actions.cancel': 'Cancel return',
    'inventory.purchaseReturn.actions.delete': 'Delete',
    'inventory.purchaseReturn.actions.deleteTitle': 'Delete draft purchase return',
    'inventory.purchaseReturn.messages.deleteConfirm': 'Delete purchase return {code}?',
    'inventory.purchaseReturn.actions.cancelTitle': 'Cancel purchase return',
    'inventory.purchaseReturn.actions.cancelConfirm': 'Cancel',
    'inventory.purchaseReturn.fields.cancelReason': 'Cancel reason',
    'inventory.purchaseReturn.errors.cancelReasonRequired':
      'Cancel reason must be at least 3 characters.',
    'inventory.purchaseReturn.errors.cancelReasonTooLong':
      'Cancel reason must not exceed {max} characters.',
    'inventory.purchaseReturn.actions.print': 'Print',
    'inventory.purchaseReturn.messages.cancelConfirm': 'Cancel purchase return {code}?',
    'inventory.purchaseReturn.sections.receipt': 'Original receipt',
    'inventory.purchaseReturn.sections.products': 'Returned products',
    'inventory.purchaseReturn.emptyLines':
      'Select a posted purchase receipt to load returnable items.',
    'inventory.hints.returnQuantity': 'Enter a quantity > 0 for items to return',
    'inventory.fields.product': 'Product',
    'inventory.fields.sku': 'SKU',
    'inventory.fields.branch': 'Branch',
    'inventory.fields.unit': 'Unit',
    'inventory.fields.quantityOnHand': 'On hand',
    'inventory.fields.allocatedQuantity': 'Allocated',
    'inventory.fields.unallocatedQuantity': 'Unallocated',
    'inventory.fields.location': 'Location',
    'inventory.fields.averageCost': 'Average cost',
    'inventory.fields.stockValue': 'Stock value',
    'inventory.fields.occurredAt': 'Occurred at',
    'inventory.fields.movementType': 'Movement type',
    'inventory.movementTypes.opening_balance': 'Opening balance',
    'inventory.movementTypes.purchase_receipt': 'Purchase receipt',
    'inventory.movementTypes.purchase_receipt_cancel': 'Cancelled purchase receipt',
    'inventory.movementTypes.purchase_return': 'Purchase return',
    'inventory.movementTypes.sales_invoice': 'Sale',
    'inventory.movementTypes.sale_return': 'Customer return',
    'inventory.movementTypes.sale_exchange': 'Exchange issue',
    'inventory.movementTypes.production_material_issue': 'Material issue',
    'inventory.movementTypes.production_output_receipt': 'Production output received',
    'inventory.movementTypes.inventory_check': 'Inventory check',
    'inventory.movementTypes.stock_transfer_out': 'Stock transfer out',
    'inventory.movementTypes.stock_transfer_in': 'Stock transfer in',
    'inventory.movementTypes.stock_transfer_return': 'Transfer difference returned',
    'inventory.movementTypes.stock_transfer_cancel': 'Cancelled transfer restored',
    'inventory.fields.sourceCode': 'Document code',
    'inventory.fields.returnCode': 'Purchase return code',
    'inventory.fields.quantityChange': 'Quantity change',
    'inventory.fields.quantityAfter': 'Quantity after',
    'inventory.fields.endingStock': 'Ending stock',
    'inventory.fields.unitCost': 'Unit cost',
    'inventory.fields.receiptCode': 'Purchase receipt code',
    'inventory.fields.receiptDate': 'Receipt date',
    'inventory.fields.totalAmount': 'Total',
    'inventory.fields.status': 'Status',
    'inventory.fields.performedBy': 'Performed by',
    'inventory.fields.updatedAt': 'Updated at',
    'inventory.fields.createdAt': 'Created at',
    'inventory.fields.postedAt': 'Completed at',
    'inventory.fields.cancelledAt': 'Cancelled at',
    'inventory.fields.balancedAt': 'Balanced at',
    'inventory.fields.cancelReason': 'Cancel reason',
    'inventory.fields.note': 'Note',
    'inventory.fields.paidAmount': 'Paid',
    'inventory.fields.quantity': 'Quantity',
    'inventory.fields.returnQuantity': 'Return quantity',
    'inventory.fields.returnDate': 'Return date',
    'inventory.fields.purchaseReceipt': 'Purchase receipt',
    'inventory.fields.lineTotal': 'Line total',
    'inventory.fields.itemCount': 'Item count',
    'inventory.fields.totalQuantity': 'Total quantity',
    'inventory.fields.discountAmount': 'Discount',
    'inventory.fields.returnableQuantity': 'Returnable',
    'inventory.fields.debtReducedAmount': 'Debt reduced',
    'inventory.stockLocation.title': 'Allocate stock by location',
    'inventory.stockLocation.subtitle': '{product} at {branch}',
    'inventory.stockLocation.actions.manage': 'Manage stock locations',
    'inventory.stockLocation.actions.add': 'Add location',
    'inventory.stockLocation.summary.total': 'Total stock',
    'inventory.stockLocation.summary.allocated': 'Allocated',
    'inventory.stockLocation.summary.unallocated': 'Unallocated',
    'inventory.stockLocation.summary.default': 'Default location',
    'inventory.stockLocation.summary.byTree': 'Location tree totals',
    'inventory.stockLocation.empty': 'This product has not been allocated to any location.',
    'inventory.stockLocation.help':
      'Allocated quantity cannot exceed total stock. Only leaf locations can be selected.',
    'inventory.stockLocation.validation.duplicate': 'Each location can only be selected once.',
    'inventory.stockLocation.validation.exceeds': 'Allocated quantity cannot exceed total stock.',
    'inventory.actions.saveDraft': 'Save draft',
    'inventory.actions.complete': 'Complete',
    'inventory.actions.payFull': 'Pay in full',
    'inventory.paymentMethods.cash': 'Cash',
    'inventory.paymentMethods.card': 'Card',
    'inventory.paymentMethods.transfer': 'Bank transfer',
    'inventory.errors.receiptMissingParty': 'Branch and supplier are required.',
    'inventory.errors.receiptMissingItems':
      'Product, unit, and a valid purchase quantity are required.',
    'inventory.errors.unitCostExceeded': 'Unit cost must not exceed {max}.',
    'inventory.errors.quantityExceeded': 'Quantity must not exceed {max}.',
    'inventory.errors.quantityMustBeInteger': 'This unit only allows whole quantities.',
    'inventory.errors.amountExceeded': 'Amount must not exceed {max}.',
    'inventory.errors.returnMissingReceipt': 'A posted purchase receipt is required.',
    'inventory.errors.returnMissingItems': 'At least one valid return line is required.',
    'inventory.errors.returnQuantityExceeded':
      'Return quantity cannot exceed the remaining returnable quantity.',
    'inventory.errors.paidAmountExceeded': 'Paid amount cannot exceed receipt total.',
    'inventory.errors.saveFailed': 'Could not save inventory data',
    'inventory.fields.checkCode': 'Check code',
    'inventory.fields.checkDate': 'Check date',
    'inventory.inventoryCheck.actions.create': 'Add inventory check',
    'inventory.inventoryCheck.actions.edit': 'Update',
    'inventory.inventoryCheck.actions.view': 'Inventory check detail',
    'inventory.inventoryCheck.actions.addProduct': 'Add product',
    'inventory.inventoryCheck.actions.import': 'Import Excel',
    'inventory.inventoryCheck.actions.export': 'Export Excel',
    'inventory.inventoryCheck.actions.print': 'Print check',
    'inventory.inventoryCheck.actions.copy': 'Copy',
    'inventory.inventoryCheck.actions.delete': 'Delete check',
    'inventory.inventoryCheck.actions.cancel': 'Cancel check',
    'inventory.inventoryCheck.actions.balance': 'Balance stock',
    'inventory.inventoryCheck.actions.merge': 'Merge checks',
    'inventory.inventoryCheck.actions.clearActualQuantity': 'Clear actual quantity',
    'inventory.inventoryCheck.sections.general': 'General information',
    'inventory.inventoryCheck.sections.products': 'Inventory products',
    'inventory.inventoryCheck.sections.totals': 'Totals',
    'inventory.inventoryCheck.sections.statistics': 'Totals',
    'inventory.inventoryCheck.mergeTitle': 'Merge inventory checks',
    'inventory.inventoryCheck.mergeConfirm':
      'Merge the {count} selected draft checks into one new check?',
    'inventory.inventoryCheck.fields.totalItems': 'Total items',
    'inventory.inventoryCheck.fields.checkedItems': 'Checked',
    'inventory.inventoryCheck.fields.uncheckedItems': 'Unchecked',
    'inventory.inventoryCheck.fields.costPrice': 'Average cost',
    'inventory.inventoryCheck.fields.systemQuantity': 'System stock',
    'inventory.inventoryCheck.fields.actualQuantity': 'Actual',
    'inventory.inventoryCheck.fields.differenceQuantity': 'Difference quantity',
    'inventory.inventoryCheck.fields.differenceValue': 'Difference value',
    'inventory.inventoryCheck.statuses.draft': 'Draft',
    'inventory.inventoryCheck.statuses.balanced': 'Balanced',
    'inventory.inventoryCheck.statuses.cancelled': 'Cancelled',
    'inventory.inventoryCheck.filters.searchPlaceholder': 'Enter check code',
    'inventory.inventoryCheck.filters.hasDifference': 'Has difference',
    'inventory.inventoryCheck.filters.yes': 'Yes',
    'inventory.inventoryCheck.filters.no': 'No',
    'inventory.inventoryCheck.cancelTitle': 'Cancel inventory check',
    'inventory.inventoryCheck.deleteTitle': 'Delete inventory check',
    'inventory.inventoryCheck.deleteConfirm':
      'Delete inventory check {code}? Only draft checks can be deleted.',
    'inventory.inventoryCheck.cancelConfirm':
      'Cancel inventory check {code}? Stock will be restored.',
    'inventory.inventoryCheck.actions.cancelConfirm': 'Cancel',
    'inventory.inventoryCheck.messages.cancelled': 'Inventory check cancelled.',
    'inventory.inventoryCheck.summary.checked': 'Checked',
    'inventory.inventoryCheck.summary.difference': 'Total difference',
    'inventory.inventoryCheck.location.title': 'Storage locations & audit breakdown',
    'inventory.inventoryCheck.location.unallocated': 'Unallocated location stock',
    'inventory.inventoryCheck.location.empty': 'Product has no assigned storage locations',
    'inventory.inventoryCheck.emptyItems': 'No products in this check.',
    'inventory.inventoryCheck.importResult':
      'Updated {updated} rows, added {added} rows. Skipped {skipped} rows.',
    'inventory.inventoryCheck.errors.branchAndItemsRequired':
      'Select a branch and add at least one product.',
    'inventory.inventoryCheck.errors.uncheckedItems': 'Enter actual quantities for all products.',
    'inventory.inventoryCheck.errors.futureDate':
      'The inventory check date cannot be in the future.',
    'inventory.inventoryCheck.errors.quantityNegative': 'Actual quantity cannot be negative.',
    'inventory.inventoryCheck.errors.actualQuantityTotalExceeded':
      'The total actual quantity across all locations must not exceed {max}.',
    'inventory.inventoryCheck.import.title': 'Import inventory check list',
    'inventory.inventoryCheck.import.subtitle':
      'Download the template, enter data, and review it before importing.',
    'inventory.inventoryCheck.import.templateTitle': 'Download template',
    'inventory.inventoryCheck.import.templateDescription':
      'The template includes instructions and the required inventory check columns.',
    'inventory.inventoryCheck.import.downloadTemplate': 'Download Excel template',
    'inventory.inventoryCheck.import.requiredLegend':
      'Provide at least one product identifier: SKU or Barcode.',
    'inventory.inventoryCheck.import.conditionalLegend':
      'Actual quantity may be left blank when the item is not checked.',
    'inventory.inventoryCheck.import.notes.identifiers':
      'Products are matched by SKU, then Barcode.',
    'inventory.inventoryCheck.import.notes.quantity':
      'Enter a non-negative actual quantity and an optional note.',
    'inventory.inventoryCheck.import.notes.format': 'Supports .xlsx and .xls files up to 5 MB.',
    'inventory.inventoryCheck.import.fileTitle': 'Choose a file to import',
    'inventory.inventoryCheck.import.fileDescription':
      'Each row is read before it is added to the inventory check.',
    'inventory.inventoryCheck.import.chooseFile': 'Choose Excel file',
    'inventory.inventoryCheck.import.supportedFormats': 'Supports .xlsx, .xls; maximum 5 MB',
    'inventory.inventoryCheck.import.rowCount': '{count} valid rows',
    'inventory.inventoryCheck.import.process': 'Import {count} rows',
    'inventory.inventoryCheck.import.errors.invalidFileType':
      'Please choose an .xlsx or .xls file.',
    'inventory.inventoryCheck.import.errors.fileTooLarge': 'The Excel file cannot exceed 5 MB.',
    'inventory.inventoryCheck.import.errors.noRows':
      'The file contains no valid inventory check rows.',
    'inventory.inventoryCheck.import.errors.cannotRead':
      'Unable to read the Excel file. Please check the file and try again.',
    'inventory.inventoryCheck.import.errors.invalidRows':
      'The file has {count} invalid rows: {reasons}',
  },
}
